import { ready } from '~/core'
import addEvents from '~/utils/addEvents'

ready('cta-banner', '.cta-banner-close', (close) => {
  const ctaBanner = close.closest('.cta-banner')
  let dismissed = window.sessionStorage.getItem('cta-banner-dismissed') || false

  const adjustPadding = () => {
    document.body.style.paddingTop = ctaBanner.offsetHeight + 'px'
  }



  if (!dismissed) {
    ctaBanner.classList.add('is-open')
  } else {
    ctaBanner.classList.remove('is-open')
    ctaBanner.style.display = 'none'
  }

  addEvents(close, 'click enter', () => {
    ctaBanner.classList.remove('is-open')
    document.body.style.paddingTop = '0'
    window.sessionStorage.setItem("cta-banner-dismissed", true)
    window.removeEventListener('resize', adjustPadding)
    ctaBanner.style.display = 'none'
    
  })
})
